import React from 'react'
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import moment from 'moment';
import { Button } from '@mui/material';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import {ReportService} from '../../business/ReportService';
import { useState, useEffect } from 'react';


const ExportToExcel = ({ api, filters, fileName, texto}) => {
  const fileType =
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
  const fileExtension = ".xlsx";

  const exportToCSV = (apiData, fileName) => {
    const ws = XLSX.utils.json_to_sheet(apiData);
    for (let i=0; i < 16; i++)
    {
      const cell = ws[XLSX.utils.encode_cell({r:0,c:i})];
      if (cell){
        cell.s = {font: { bold : true}}
      }
    }
    const wb = { Sheets: { data: ws }, SheetNames: ['data'] };
    
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    
    const data = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(data, fileName + fileExtension);
  };

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [filter, setFilterStatus] = useState(filters);
  const [xlsData, setXlsData] = useState([]);
  
  
  const getQuotas = async () => { 

    const accountInstance = ReportService.getInstance();
    setLoading(true);
    await accountInstance.getQuotas(filter)
    .then((data) => {
        if(data){
          data = data.map((row) => ({...row, 
              quotaDate: moment(row.quotaDate).format("DD/MM/YYYY"),
              endDate: row.endDate !== null ? moment(row.endDate).format("DD/MM/YYYY") : '',
            }))
          
          let  clonexlsData = data.map((col, index) => { return {
            "Primer Apellido": col.lastName,
            "Segundo Apellido": col.secondLastname,
            "Nombres": col.names,
            "Tipo de documento": col.docType,
            "Nro de documento": col.docNumber,
            "Producto": col.product,
            "Fecha cuota": col.quotaDate,
            "Monto de cuota": col.returnAmount,
            "Fecha termino": col.endDate,
            "Monto de devolucion": col.returnAmount,
            "Pago cupón": col.coupon,
            "Retencion": col.retention,
            "Banco": col.bank,
            "Numero de cuenta": col.bankAccount,
            "cci": col.cci,
            "Asesor": col.advisor,
            
          }});
          exportToCSV(clonexlsData, fileName);
       
          setLoading(false);
        }   
        
    })
    .catch((err) => {
      console.log(err);
      setLoading(false);
    });

    
  }

  function getData(api){
    switch (api){
      case 'get-quotas': getQuotas();
  
    }
  }
  


  return (
    <Button onClick={(e) => getData(api)}><FileDownloadOutlinedIcon /> {texto}</Button>
  );
};

export default ExportToExcel;